<template>
    <div class="col-lg-12 col-md-12 wrapper container">
      <card type="tasks" class="pb-1">
        <template slot="header">
          <h6 class="title d-inline">{{$t('dashboard.tasks', {count: tasks ? tasks.length : 0})}}</h6>
          <p class="card-category d-inline">{{$t('dashboard.today')}}</p>
          <base-button v-tooltip="'Adauga task nou'" @click="addTask" type="info" size="sm" icon class="pull-right">
            <i class="tim-icons icon-simple-add"></i>
          </base-button>
        </template>
        <div class="table-full-width table-responsive" style="height: 100%; overflow-x: hidden; margin-bottom: -10px">
          <base-table :data="tasks"
                      thead-classes="text-primary">
            <template slot-scope="{row}">
              <td width="10px">
                <base-checkbox v-model="row.done" @input="updateTaskStatus(row)"></base-checkbox>
              </td>
              <td width="100px">
                {{ getFormatedCreatedDate(row.created_at)}}
              </td>
              <td>
                <p class="title" v-bind:class="{'line-through': row.done}">{{row.title}}</p>
                <p class="text-muted" v-bind:class="{'line-through': row.done}">{{row.description}}</p>
              </td>
              <td class="td-actions text-right">
                <base-button :disabled="row.done" type="link" aria-label="edit button" @click="editTask(row)">
                  <i class="tim-icons icon-pencil"></i>
                </base-button>
              </td>
            </template>
          </base-table>
        </div>
      </card>
      <VModal name="edit_task" height="auto" :scrollable="true" width="550">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Adauga/Editeaza task</h4>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="$modal.hide('edit_task')">×</button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12" v-bind:class="{'has-danger' : $v.edited_row.title.$error, 'has-success' : !$v.edited_row.title.$error && edited_row.title}">
                <base-input :error="$v.edited_row.title.$error"
                            @input="$v.edited_row.title.$touch"
                            label="Titlu*"
                            placeholder="Titlu"
                            v-model="edited_row.title">
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <base-input label="Descriere"
                            placeholder="Descriere"
                            v-model="edited_row.description">
                </base-input>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <base-button class="btn-primary btn-sm" @click="saveTask()">Salveaza</base-button>
          </div>
        </div>
      </VModal>
    </div>
</template>
<script>
  import {BaseTable} from '@/components';
  import axios from "axios";
  import Modal from "../../components/Modal";
  const { required } = require('vuelidate/lib/validators');

  export default {
    components: {
      Modal,
      BaseTable
    },
    validations: {
      edited_row: {
        title: {required},
      }
    },
    data() {
      return {
        tasks: null,
        showModal: false,
        edited_row: {
          title: '',
          description: '',
          done: 0,
        },
      }
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        axios.post('tasks')
                .then(res => {
                  this.tasks = res.data;
                })
                .catch(err => {
                  console.log(err);
                })
      },
      getFormatedCreatedDate(created_at) {
        return new Date(created_at).toLocaleDateString('ro');
      },
      editTask(row) {
        this.edited_row = row;
        this.$modal.show('edit_task');
      },
      updateTaskStatus(row) {
        console.log('test');
        axios.post('task/update-status', row)
                .then(res => {
                  this.getData();
                  this.notifySuccess();
                })
                .catch(err => {
                  console.log(err);
                })
      },
      saveTask() {
        this.$v.edited_row.$touch();
        if (this.$v.edited_row.$error === true) {
          return false;
        }
        axios.post('task/save', this.edited_row)
                .then(res => {
                  this.$modal.hide('edit_task');
                  this.getData();
                  this.notifySuccess();
                })
                .catch(err => {
                  console.log(err);
                })
      },
      addTask() {
        this.edited_row = {
          title: '',
          description: '',
          done: 0,
        };
        this.$modal.show('edit_task');
      },
      notifySuccess() {
        this.$notify({
          type: 'success',
          message: 'Task salvat cu succes',
          icon: 'tim-icons icon-bell-55',
        })
      },
    }
  }
</script>
<style scoped>
  .line-through {
    text-decoration-line: line-through;
    text-decoration-thickness: 2px;
  }
</style>
